import React from "react";
import { RadioButComp } from "../../../inputs/fields.component";

const MetricRadioGroup = props => {
  const {
    radioSelector,
    setRadioSelector,
    radioGroupName,
    items,
    subclassDefined
  } = props;

  return (
    <div className="metric-radio-container">
      {items.map(item => {
        return (
          <RadioButComp
            key={item.id}
            id={item.id}
            label={item.label}
            subclassDefined={subclassDefined}
            onClick={() => setRadioSelector(item.id)}
            radioButProps={{
              name: radioGroupName,
              defaultChecked: !!(radioSelector === item.id)
            }}
          />
        );
      })}
    </div>
  );
};

export default MetricRadioGroup;
